define.alias("ember-composable-helpers/helpers/chunk", "calendar/helpers/chunk");